import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root'
})
export class SupplementaryAccountsService {

  constructor(
    private apiService: ApiService
  ) { }

  loadSupplementaryAccounts() {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS);
  }

  createSupplementaryAccount(params) {

    const formData = new FormData();
    Object.entries(params.supplementary_account).forEach(([key, value]) => {

      if (key !== 'locations_attributes') {
        formData.set(`supplementary_account[${key}]`, value as string);
      } else {
        // console.log(params);
        if (key == 'locations_attributes') {
          Object.entries(params.supplementary_account['locations_attributes'][0]).forEach(([k, v]) => {
            formData.set(`supplementary_account[${key}][0]${k}`, v.toString() as string);
          });
        }
      }
    });

    return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS, formData);
  }

  loadSupplementaryAccount(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + '/' + userId);
  }
  loadSupplementaryAccountNew(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId);
  }

  fetchSetting(userId) {
    if (userId) {
      return this.apiService.get(
        API_ENDPOINTS.BASE_URL +
        API_ENDPOINTS.VERSION +
        API_ENDPOINTS.API.USERS + '/' + userId +
        API_ENDPOINTS.API.PROFILE_SETTINGS);
    }
  }

  updateUser(userId, userData) {
    return this.apiService.patch(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId, userData);
  }

  updateConnectionSetting(settingData, userId) {
    if (userId) {
      return this.apiService.put(
        API_ENDPOINTS.BASE_URL +
        API_ENDPOINTS.VERSION +
        API_ENDPOINTS.API.USERS +
        '/' + userId +
        API_ENDPOINTS.API.PROFILE_SETTINGS +
        '/' + API_ENDPOINTS.API.CHANGE_PRIVACY_SETTING, settingData);
    }
  }

  updateSetting(type, settingData, userId) {
    if (userId) {
      return this.apiService.put(
        API_ENDPOINTS.BASE_URL +
        API_ENDPOINTS.VERSION +
        API_ENDPOINTS.API.USERS +
        '/' + userId +
        API_ENDPOINTS.API.PROFILE_SETTINGS +
        '/' + type, settingData);
    }
  }
  delteSupplementaryUser(userId) {
    return this.apiService.delete(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId);
  }
  updateSupplementaryUser(userId, userData) {

    const formData = new FormData();
    Object.entries(userData.supplementary_account).forEach(([key, value]) => {

      if (key !== 'locations_attributes') {
        formData.set(`supplementary_account[${key}]`, value as string);
      } else {
        if (key == 'locations_attributes') {
          Object.entries(userData.supplementary_account['locations_attributes'][0]).forEach(([k, v]) => {
            formData.set(`supplementary_account[${key}][0]${k}`, v.toString() as string);
          });
        }
      }
    });

    return this.apiService.patch(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId, formData);
  }

  updateSupplementaryUserAvatar(userId, userData) {

    const formData = new FormData();
    formData.set('avatar', userData['avatar'])

    return this.apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId + API_ENDPOINTS.API.SUPPLEMENTARY_USER_AVATAR, formData);
  }

  recentActivities(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + `/${userId}/` + API_ENDPOINTS.API.RECENT_ACTIVITY);
  }

  walletDetails(userId, params) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + `/${userId}` + API_ENDPOINTS.API.TRANSACTION_DETAILS + params);
  }

  fetchTokens(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + `/${userId}/` + API_ENDPOINTS.API.FETCH_TOKENS);
  }

  getPendingContents(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + `/${userId}` + API_ENDPOINTS.API.PENDING_CONTENTS);
  }

  approveDeclinePendingRequest(userId, contentId, contentStatus) {
    return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId + API_ENDPOINTS.API.APPROVE_DECLINE_CONTENT + `?content_id=${contentId}&status=${contentStatus}`);
  }

  getWIPContent(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENTS + `/?category_type=created&library_type=wipod&page=1&user_id=${userId}`);
  }

  loadSentRequest(userId, params) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId + '/get_supplementary_connections' + params);
  }

  approveDeclineChildRequest(userId, params) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId + '/connection_approval', params);
  }

  getSentGifts(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.GIFT + API_ENDPOINTS.API.SUPP_SENT_CONTENT_LIST + '?user_id=' + userId);
  }

  saMakePrimary(userId, action) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId + API_ENDPOINTS.API.MAKE_PRIMARY_ACCOUNT + '?action_performed=' + action);
  }

  enableSa(userId){
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPPLEMENTARY_USERS + '/' + userId +'/enable_supplementary_user');
  }
}
